/*
req.user object:
1. For PERSONAL accounts, accountType=PERSONAL, no userType
2. For BUSINESS accounts, accountType=BUSINESS, no userType
3. For IDENTITY account, accountType=BUSINESS & userType=IDENTITY
*/

export const getUserType = (user) => {
  const userType =
    user.accountType && user.userType !== 'IDENTITY'
      ? user.accountType
      : user.userType

  return userType
}
